// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryTimer_wrapper","santa":"CategoryTimer_santa","info":"CategoryTimer_info","title":"CategoryTimer_title","timer":"CategoryTimer_timer"};